import { Card, CardBody, CardHeader } from '@/shared/ui/Card';
import { MoneyField } from '@/shared/ui/MoneyField';

import { CAMPOS_DA_EXPOSICAO, campoAtivo, type EstadoDaExposicao } from './exposicao';

/**
 * Exposicao ficticia do tomador (ADR 0088, secao 10). Na execucao real ela vem da
 * carteira; aqui cada valor informado vira uma dimensao calculavel, e o valor em branco
 * deixa a regra como sem exposicao.
 */
export function ExposicaoFicticia({
  estado,
  erros,
  erroDoServidor,
  onChange,
}: {
  estado: EstadoDaExposicao;
  erros: Record<string, string>;
  erroDoServidor?: string | undefined;
  onChange: (estado: EstadoDaExposicao) => void;
}) {
  const atualizar = (parcial: Partial<EstadoDaExposicao>) =>
    onChange({ ...estado, ...parcial });
  return (
    <Card>
      <CardHeader
        title="Exposicao ficticia do tomador"
        description="Limite disponivel e acumulo sem a propria operacao, como a execucao real le da carteira. Nada da carteira e lido ou alterado."
      />
      <CardBody className="flex flex-col gap-4">
        <label className="flex items-center gap-2 text-sm text-ink-700">
          <input
            type="checkbox"
            checked={estado.ligada}
            onChange={(event) => atualizar({ ligada: event.target.checked })}
          />
          Incluir a exposicao ficticia (LIM-001, LIM-002, LIM-004, LIM-008 e LIM-011)
        </label>
        {estado.ligada ? (
          <>
            <div className="flex flex-wrap gap-6">
              <label className="flex items-center gap-2 text-sm text-ink-700">
                <input
                  type="checkbox"
                  checked={estado.grupoIdentificado}
                  onChange={(event) =>
                    atualizar({ grupoIdentificado: event.target.checked })
                  }
                />
                Tomador com grupo economico
              </label>
              <label className="flex items-center gap-2 text-sm text-ink-700">
                <input
                  type="checkbox"
                  checked={estado.ccgFormalizada}
                  onChange={(event) =>
                    atualizar({ ccgFormalizada: event.target.checked })
                  }
                />
                CCG da operacao formalizada
              </label>
            </div>
            <div className="grid gap-4 sm:grid-cols-2">
              {CAMPOS_DA_EXPOSICAO.map((campo) => (
                <MoneyField
                  key={campo.campo}
                  label={campo.rotulo}
                  disabled={!campoAtivo(campo, estado)}
                  value={estado[campo.campo]}
                  hint={`${campo.ajuda} Em branco, nao informado.`}
                  error={erros[`exposicao.${campo.campo}`]}
                  onValueChange={(texto) => atualizar({ [campo.campo]: texto })}
                />
              ))}
            </div>
            {erroDoServidor ? (
              <p className="text-sm text-danger-700" role="alert">
                {erroDoServidor}
              </p>
            ) : null}
          </>
        ) : null}
      </CardBody>
    </Card>
  );
}
